module.exports = __webpack_public_path__ + "img/车辆买卖客服弹窗.818dd470.png";